// extracted by mini-css-extract-plugin
module.exports = {"container":"Contacts_container__Cm2eA","inner":"Contacts_inner__17oX4","contactInfo":"Contacts_contactInfo__3dDVa"};